import StickyPageHeader from '../components/common/StickyPageHeader';
import ShipTypeList from '../components/lists/ShipTypeList';
import { useShipTypes } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminShipTypesPage = ({ disableLayout, routes }) => {
  const { allShipTypes } = useShipTypes();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Ship Types" />
      <ShipTypeList id="shipTypes" shipTypes={allShipTypes} />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminShipTypesPage;
